const state = {
    lines: [],
    error: null,
    editLine: false
};

export default state;
